// TODO: change on deploy

let baseUrl = "http://localhost:3000";
let tempbackendServerBaseURL = "http://localhost:7501/api/v2";
let tempbackendServerBaseURL2 = "http://localhost:3001/api";
let tempMediaServerBaseURL = "https://resell.lightningproxies.net";
let tempfrontendServerBaseURL = "https://resell.lightningproxies.net";

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  console.log("dev");
} else {
  tempbackendServerBaseURL = "https://resell.lightningproxies.net/api/v2";
  tempbackendServerBaseURL2 = "https://resell.lightningproxies.net/api";
  tempfrontendServerBaseURL = "https://resell.lightningproxies.net";
  tempMediaServerBaseURL = "https://resell.lightningproxies.net/static";
}

export let backendServerBaseURL = tempbackendServerBaseURL;
export let backendServerBaseURL2 = tempbackendServerBaseURL2;
export let frontendServerBaseURL = tempfrontendServerBaseURL;
export let mediaServerBaseURL = tempMediaServerBaseURL;
